module.exports = __webpack_public_path__ + "static/media/mt.cb88a36d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mt.svg
// module id = 2163
// module chunks = 0